import {
  RelationBenefitAutomaticTypeConfiguration,
  SubscriptionRelationType,
} from "web/types/Subscription";
import { Nullable } from "web/types/Utils";

const HIDDEN_AUTOMATIC_BENEFIT_CONFIGURATIONS = [
  RelationBenefitAutomaticTypeConfiguration.HIDE_IN_MY_SUBSCRIPTIONS_VIEW,
  RelationBenefitAutomaticTypeConfiguration.HIDE_WHEN_CHOOSING_BENEFITS,
];

const isHiddenAutomaticBenefit = (benefit: {
  relationBenefitAutomaticTypeConfiguration?: Nullable<
    RelationBenefitAutomaticTypeConfiguration[]
  >;
  relationBenefitTypeConfiguration: SubscriptionRelationType;
}) =>
  benefit.relationBenefitTypeConfiguration === "auto" &&
  benefit.relationBenefitAutomaticTypeConfiguration?.some((configuration) =>
    HIDDEN_AUTOMATIC_BENEFIT_CONFIGURATIONS.includes(configuration)
  );

export default isHiddenAutomaticBenefit;